import { Navigate, Outlet } from "react-router-dom";
import { getHrEmployeeSession } from "@/lib/auth/storage";

export function EmployeeAuthGuard() {
  if (!getHrEmployeeSession()) {
    return <Navigate to="/employee/login" replace />;
  }
  return <Outlet />;
}
